import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MyWork from "@/pages/MyWork";
import SmmWorkspace from "@/pages/SmmWorkspace";
import DesignPool from "@/pages/DesignPool";
import VideoPool from "@/pages/VideoPool";
import AccountWorkspace from "@/pages/AccountWorkspace";
import TeamProgress from "@/pages/TeamProgress";
import ActivityLog from "@/pages/ActivityLog";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import ContentCalendar from "@/pages/ContentCalendar";
import SpecialDays from "@/pages/SpecialDays";
import Backups from "@/pages/Backups";
import Publishing from "@/pages/Publishing";
import Tasks from "@/pages/Tasks";
import Team from "@/pages/Team";
import Shoots from "@/pages/Shoots";
import Payments from "@/pages/Payments";
import Settings from "@/pages/Settings";
import { JOB_WORKSPACE } from "@/lib/meta";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-zinc-400" /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (user?.role === "super_admin" || user?.role === "manager") return <Dashboard />;
  const ws = JOB_WORKSPACE[user?.job_role];
  if (ws === "smm") return <SmmWorkspace />;
  if (ws === "design") return <DesignPool />;
  if (ws === "video") return <VideoPool />;
  if (ws === "account") return <AccountWorkspace />;
  return <MyWork />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Home />} />
              <Route path="team-progress" element={<TeamProgress />} />
              <Route path="activity" element={<ActivityLog />} />
              <Route path="design-pool" element={<DesignPool />} />
              <Route path="video-pool" element={<VideoPool />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route path="calendar" element={<ContentCalendar />} />
              <Route path="special-days" element={<SpecialDays />} />
              <Route path="backups" element={<Backups />} />
              <Route path="publishing" element={<Publishing />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="team" element={<Team />} />
              <Route path="shoots" element={<Shoots />} />
              <Route path="payments" element={<Payments />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
